import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-20 w-20 text-stone-600 mx-auto mb-6" />
      <h1 className="font-display text-3xl text-stone-100 mb-3">Paiement annulé</h1>
      <p className="text-stone-400 mb-8">
        Aucun montant n'a été débité. Votre panier est conservé, vous pouvez reprendre quand vous voulez.
      </p>
      <div className="flex items-center justify-center gap-3">
        <Link to="/paiement" className="btn-ember rounded-xl px-6 py-3">Reprendre le paiement</Link>
        <Link to="/boutique" className="px-6 py-3 rounded-xl border border-amber-900/40 text-stone-300 hover:border-amber-600">Continuer mes achats</Link>
      </div>
    </div>
  );
}
